import { connect } from 'react-redux';
import Homepage from './HomePage';

function mapStateToProps({ marketing }) {
  return {
    platformTotals: marketing.platformTotals,
    savedByUser: marketing.savedByUser,
  };
}

export default connect(mapStateToProps)(Homepage);
